import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import {
    PriceTable,
    UpdatePriceTablePayload,
} from 'app/types/catalogue/priceTable'

export const updatePriceTable = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.priceTables.DETAILS}`,
    async ({ params, request }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = UpdatePriceTablePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const managerFound = allManagers.find(
            (manager) => manager.id.toString() === id,
        )

        // Not found
        if (!managerFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<PriceTable>({
            client: managerFound,
            id: Number.parseInt(id.toString(), 10),
            name: '',
            standard: true,
        })
    },
)
